import api from './api';
import { PackageModel, CreatePackageModelData, UpdatePackageModelData } from '../types/packageModel';

export const packageModelService = {
  // Get all models for a package
  getByPackage: async (
    workspaceId: string,
    packageId: string
  ) => {
    const response = await api.get(
      `/workspaces/${workspaceId}/pkg-packages/${packageId}/models`
    );
    return response.data;
  },

  // Add a model to a package
  create: async (
    workspaceId: string,
    packageId: string,
    data: CreatePackageModelData
  ) => {
    const response = await api.post(
      `/workspaces/${workspaceId}/pkg-packages/${packageId}/models`,
      data
    );
    return response.data;
  },

  // Add multiple models to a package
  createMultiple: async (
    workspaceId: string,
    packageId: string,
    models: CreatePackageModelData[]
  ) => {
    const response = await api.post(
      `/workspaces/${workspaceId}/pkg-packages/${packageId}/models/bulk`,
      { models }
    );
    return response.data;
  },

  // Update a model in a package
  update: async (
    workspaceId: string,
    packageId: string,
    modelId: string,
    data: UpdatePackageModelData
  ) => {
    const response = await api.put(
      `/workspaces/${workspaceId}/pkg-packages/${packageId}/models/${modelId}`,
      data
    );
    return response.data;
  },

  // Remove a model from a package
  delete: async (
    workspaceId: string,
    packageId: string,
    modelId: string
  ) => {
    const response = await api.delete(
      `/workspaces/${workspaceId}/pkg-packages/${packageId}/models/${modelId}`
    );
    return response.data;
  }
};
